import {Modal} from "react-bootstrap";
import {Cropper} from "react-advanced-cropper";
import Button from "@mui/material/Button";
import t from "../../Utils/Translation";
import React, {useRef, useState} from "react";
import {base64StringToFile} from "../../Utils/ImageCropUtils";
import Form from "react-bootstrap/Form";
import Tooltip from "@mui/material/Tooltip";
import Image from "react-bootstrap/Image";

const CoverImageInput = ({setCoverImageFile, coverImageFile}) => {
    const [showCropModal, setShowCropModal] = useState(false)
    const [imgSrc, setImgSrc] = useState(null)
    const cropperRef = useRef();
    const [image, setImage] = useState(null)
    const fileInputRef = useRef();


    const onImageChange = (event) => {
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];
            if(file.type.startsWith("image")){
                setImgSrc(URL.createObjectURL(file))
                setCoverImageFile(event.target.files[0]);
                setShowCropModal(true)
                // event.target.value = "";
            }
        }
    }

    const handleSaveCrop = () => {
        const cropper = cropperRef.current;
        const canvas = cropper.getCanvas()
        setImage(canvas.toDataURL())
        const newFile = base64StringToFile(canvas.toDataURL(), coverImageFile.name)
        setCoverImageFile(newFile)
        setShowCropModal(false)
    }

    return (
        <>

            <Form.Group controlId="coverImg" className="mb-3">
                <Form.Label>{t('Cover Image')} &nbsp;
                    <Tooltip title={t('You can upload all popular image files.')}>
                        <i className="bi bi-info-square"></i>
                    </Tooltip>
                </Form.Label>
                <Form.Control
                    ref={fileInputRef}
                    filename={coverImageFile}
                    accept="image/*"
                    required
                    type="file"
                    onChange={(e) => {
                        onImageChange(e);
                    }}
                />
            </Form.Group>

            {image && <div className="lykiocss-create-file-showcase">
                <Image fluid src={image} alt="preview image"/>
            </div> }
            <Modal

                show={showCropModal}
                onHide={() => setShowCropModal(false)}
                backdrop="static"
                keyboard={false}
            >

                <Modal.Body>
                    <Cropper
                        src={imgSrc}
                        ref={cropperRef}
                        stencilProps={{
                            aspectRatio: 1/1
                        }}
                        // onChange={handleOnCropChange}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => handleSaveCrop()}>
                        {t("Crop")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )

}

export default CoverImageInput;